import { useContext } from 'react';

import { ISharedAppContextV2, SharedAppContextV2 } from '@origin-digital/shared-app-context';

export const useSharedAppContext = (): ISharedAppContextV2 =>
  useContext<ISharedAppContextV2>(SharedAppContextV2);
